import React, { useEffect } from 'react';
import { FileText, Handshake, Users, Users2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import StatsCard from './StatsCard';
import { useNavigate } from 'react-router-dom';
import { useAdminStore } from '../../../stores/adminStore';
import EyeButton from '../../common/EyeButton';
import { LoadingSpinner } from '../../LoadingSpinner';

const StatsDashboard: React.FC = () => {
  const { t } = useTranslation(['admin']);

  const { dashboard_stats, fetchStats } = useAdminStore();

  const navigate = useNavigate();

  useEffect(() => {
    fetchStats().catch(() => {
      toast.error(t('generic_error', { ns: 'common' }));
    });
  }, [fetchStats, t]);

  return (
    <>
      {dashboard_stats.total_freelancers ? (
        <div className="flex flex-wrap gap-4">
          <StatsCard
            title={t('navigation.recruiters', { ns: 'admin' })}
            value={dashboard_stats.total_recruiters ?? 0}
            icon={<Users2 className="text-primary size-6" />}
            badge={{
              content: <EyeButton />,
              color: 'success',
            }}
            onClick={() => navigate('/admin/users', { state: { role: 'recruiter' } })}
          />

          <StatsCard
            title={t('navigation.freelancers', { ns: 'admin' })}
            value={dashboard_stats.total_freelancers}
            icon={<Users className="text-primary size-6" />}
            badge={{
              content: <EyeButton />,
              color: 'success',
            }}
            onClick={() => navigate('/admin/users', { state: { role: 'freelancer' } })}
          />

          <StatsCard
            title={t('navigation.reports', { ns: 'admin' })}
            value={dashboard_stats.total_reports ?? 0}
            icon={<FileText className="text-primary size-6" />}
            badge={{
              content: <EyeButton />,
              color: 'success',
            }}
            onClick={() => navigate('/admin/reports')}
          />

          <StatsCard
            title={t('navigation.jobs', { ns: 'admin' })}
            value={dashboard_stats.total_jobs ?? 0}
            icon={<Handshake className="text-primary size-6" />}
            badge={{
              content: <EyeButton />,
              color: 'success',
            }}
            onClick={() => navigate('/admin/jobs')}
          />
        </div>
      ) : (
        <div>
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

export default StatsDashboard;
